import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Supabase client — initialised once here, import from './supabase' anywhere you need it
import './supabase';

import TradeFlowLanding from './componet/tradeflowlanding';
import SignUp           from './componet/user/signup';
import Login            from './componet/user/login';
import About            from './componet/about';
import Dashboard        from './dashboard/dashboard';
import CopyTrading      from './dashboard/CopyTrading';
import HireTrader       from './dashboard/Hiretrader';
import TradingTerminal  from './dashboard/terminal';
import Marketplace      from './dashboard/MarketPlace';
import Policy           from './componet/policy';
import Terms            from './componet/terms';
import Insights         from './dashboard/insights';
import Profile          from './dashboard/profile';
import Settings         from './dashboard/settings';
import Support          from './dashboard/support';
import Payment          from './dashboard/payment';
import Notifications    from './dashboard/notification';
import Subscription from './dashboard/subscription';
import Privacy from './componet/privacy';
import Disclosures from './componet/disclosures';
import Stocks from './dashboard/stock';
import AdminLogin from './admin/admin_login'; 
import AdminDashboard from './admin/admin_dashboard';
import AdminLayout    from "./admin/AdminLayout";
import CopyTrades from './admin/copy_trades';
import Traders from './admin/traders';
import Transactions from './admin/transactions';
import AdminMarketplace from './admin/marketplace';
import AdminNotifications from './admin/notifications';
import Stockstrades from './admin/stocks_trade';
import AdminSupport from './admin/support';
import Trading from './admin/trading';
import Wallets from './admin/wallets';
import StockTrades from './admin/stocks_trade';
import UsersPage from './admin/users';
import AdminSubscription from './admin/subscription_plans';
import AdminPaymentsAddress from './admin/payment_address';
import ForgotPassword from './componet/user/forget_password';
import AdminMarketSubscriptions from './admin/marketplace_subscription';
import DocsPage from './dashboard/docs';
import CommunityPage from './dashboard/community';
import StatusPage from './dashboard/status';
import AdminNews from './admin/AdminNews';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/"             element={<TradeFlowLanding />} />
        <Route path="/about"        element={<About />} />
        <Route path="/signup"       element={<SignUp />} />
        <Route path="/login"        element={<Login />} />
        <Route path="/dashboard"    element={<Dashboard />} />
        <Route path="/copy-trading" element={<CopyTrading />} />
        <Route path="/hire-trader"  element={<HireTrader />} />
        <Route path="/terminal"     element={<TradingTerminal />} />
        <Route path="/market-place" element={<Marketplace />} />
        <Route path="/cookie"       element={<Policy />} />
        <Route path="/terms"        element={<Terms />} />
        <Route path="/insights"     element={<Insights />} />
        <Route path="/profile"      element={<Profile />} />
        <Route path="/settings"     element={<Settings />} />
        <Route path="/support"      element={<Support />} />
        <Route path="/payments"     element={<Payment />} />
        <Route path="/notification" element={<Notifications />} />
        <Route path='/billing' element={<Subscription />} />
        <Route path="*" element={<h1>404 Not Found</h1>} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/disclosures" element={<Disclosures />} />
        <Route path="/stocks" element={<Stocks />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path='/admin' element={<AdminDashboard />} />
        <Route path="/admin/copy-trades" element={<CopyTrades />} />
        <Route path="/admin/traders" element={<Traders />} />
        <Route path='/admin/transactions' element={<Transactions />} />
        <Route path='/admin/wallets' element={<Wallets />} />
        <Route path='/admin/marketplace' element={<AdminMarketplace />} />
        <Route path='/admin/stock-trades' element={<StockTrades />} />
        <Route path='/admin/support' element={<AdminSupport />}/>
        <Route path='/admin/notifications' element={<AdminNotifications />}/>
        <Route path='/admin/users' element={<UsersPage />}/>
        <Route path='/admin/trading' element={<Trading />}/>
        <Route path='/admin/subscriptions' element={<AdminSubscription />}/>
        <Route path='/admin/payment-addresses' element={<AdminPaymentsAddress />}/> 
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/admin/market-subscriptions" element={<AdminMarketSubscriptions />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/status" element={<StatusPage />} />
        <Route path="/admin/news" element={<AdminNews />} />

      </Routes>
    </Router>
  );
}

export default App;